import { render, staticRenderFns } from "./ResizableGrids.vue?vue&type=template&id=2887ddf3&scoped=true&"
import script from "./ResizableGrids.vue?vue&type=script&lang=js&"
export * from "./ResizableGrids.vue?vue&type=script&lang=js&"
import style0 from "./ResizableGrids.vue?vue&type=style&index=0&id=2887ddf3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887ddf3",
  null
  
)

export default component.exports